<div class="container pt-2" style="max-width: 100%;">
    <div class="row">
        <div class="col-12 col-md-6">
            <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

            <div class="col-12 col-md-6">
                <div class="tab-buttons">
                    <button class="btn btn-primary" [class.active]="selectedTab === 1" (click)="selectedTab = 1">
                        Globales
                    </button>

                    <button class="btn btn-primary" [class.active]="selectedTab === 2" (click)="selectedTab = 2">
                        Operacionales
                    </button>

                    <button class="btn btn-primary" [class.active]="selectedTab === 3" (click)="selectedTab = 3">
                        Dotación
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="pt-4">
        <ng-container *ngIf="selectedTab === 1">
            <div class="row align-items-center mb-3">

                <!-- IZQUIERDA -->
                <div class="col-12 col-md-6">
                    <h1 class="mb-1 page-title">Indicadores Globales a la Fecha</h1>
                    <p class="subtitle">*En millones de Pesos</p>
                </div>

                <!-- DERECHA -->
                <div class="col-12 col-md-6 d-flex justify-content-md-end gap-3 mt-3 mt-md-0">

                    <!-- Select -->
                    <select class="form-select" style="max-width: 180px;" formControlName="periodoFiltro">
                        <option value="">Seleccione Área</option>
                        <option value="mensual">Mensual</option>
                        <option value="trimestral">Trimestral</option>
                    </select>

                    <!-- Input Fecha -->
                    <input type="date" class="form-control" style="max-width: 180px;" formControlName="fechaFiltro" />



                </div>

            </div>


            <div class="row mt-4 cards-resumen">

                <div class="col-12 col-md-4">
                    <div class="card-resumen">
                        <h4>Ingresos</h4>
                        <p class="monto">$200.000.000</p>
                        <p class="info">LLevamos 30% del ingreso proyectado</p>
                    </div>
                </div>

                <div class="col-12 col-md-4">
                    <div class="card-resumen">
                        <h4>Gastos</h4>
                        <p class="monto">$200.000.000</p>
                        <p class="info">LLevamos 30% del ingreso proyectado</p>
                    </div>
                </div>

                <div class="col-12 col-md-4">
                    <div class="card-resumen">
                        <h4>Desviación</h4>
                        <p class="monto">$200.000.000</p>
                        <p class="info">LLevamos 30% del ingreso proyectado</p>
                    </div>
                </div>





            </div>

            <div class="row mt-4 cards-resumen">
                <div class="col-12 col-md-4">
                    <div class="card-resumen">
                        <div id="chart">
                            <apx-chart
                            [series]="chartOptionsIngresos.series"
                            [chart]="chartOptionsIngresos.chart"
                            [plotOptions]="chartOptionsIngresos.plotOptions"
                            [dataLabels]="chartOptionsIngresos.dataLabels"
                            [xaxis]="chartOptionsIngresos.xaxis"
                            [colors]="chartOptionsIngresos.colors"
                            [fill]="chartOptionsIngresos.fill"
                            ></apx-chart>


                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4">
                    <div class="card-resumen">
                        <div id="chart">
                            <apx-chart
                            [series]="chartOptionsGatos.series"
                            [chart]="chartOptionsGatos.chart"
                            [plotOptions]="chartOptionsGatos.plotOptions"
                            [dataLabels]="chartOptionsGatos.dataLabels"
                            [xaxis]="chartOptionsGatos.xaxis"
                            [colors]="chartOptionsGatos.colors"
                            [fill]="chartOptionsGatos.fill"
                            ></apx-chart>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-4">
                    <div class="card-resumen">
                        <div id="chart">
                            <apx-chart
                            [series]="chartOptionsDesviacion.series"
                            [chart]="chartOptionsDesviacion.chart"
                            [plotOptions]="chartOptionsDesviacion.plotOptions"
                            [dataLabels]="chartOptionsDesviacion.dataLabels"
                            [xaxis]="chartOptionsDesviacion.xaxis"
                            [colors]="chartOptionsDesviacion.colors"
                            [fill]="chartOptionsDesviacion.fill"
                            ></apx-chart>
                        </div>
                    </div>
                </div>
            </div>


            <div class="row mt-4 cards-resumen">
                <div class="col-12 col-md-6">
                    <div class="card-resumen">
                        <apx-chart
                            [series]="chartOptionsDistribucionCostoMargen.series"
                            [chart]="chartOptionsDistribucionCostoMargen.chart"
                            [plotOptions]="chartOptionsDistribucionCostoMargen.plotOptions"
                            [dataLabels]="chartOptionsDistribucionCostoMargen.dataLabels"
                            [xaxis]="chartOptionsDistribucionCostoMargen.xaxis"
                            [colors]="chartOptionsDistribucionCostoMargen.colors"
                            [fill]="chartOptionsDistribucionCostoMargen.fill"
                            ></apx-chart>
                    </div>
                </div>

                <div class="col-12 col-md-6">
                    <div class="card-resumen">
                        <apx-chart
                            [series]="donutChartOptions.series"
                            [chart]="donutChartOptions.chart"
                            [labels]="donutChartOptions.labels"
                            [colors]="donutChartOptions.colors"
                            [legend]="donutChartOptions.legend"
                            [dataLabels]="donutChartOptions.dataLabels"
                            [plotOptions]="donutChartOptions.plotOptions"
                            [responsive]="donutChartOptions.responsive" style="margin-top: 40px;">
                        </apx-chart>
                    </div>
                </div>

            </div>

            <div class="row mt-4 cards-resumen">
                <div class="col-12 col-md-12">
                    <div class="card-resumen">
                        <apx-chart
                        [series]="chartOptionsEjecuccionProyectosMensaluales.series"
                        [chart]="chartOptionsEjecuccionProyectosMensaluales.chart"
                        [plotOptions]="chartOptionsEjecuccionProyectosMensaluales.plotOptions"
                        [dataLabels]="chartOptionsEjecuccionProyectosMensaluales.dataLabels"
                        [xaxis]="chartOptionsEjecuccionProyectosMensaluales.xaxis"
                        [colors]="chartOptionsEjecuccionProyectosMensaluales.colors"
                        [fill]="chartOptionsEjecuccionProyectosMensaluales.fill"
                        [stroke]="chartOptionsEjecuccionProyectosMensaluales.stroke"
                        ></apx-chart>
                    </div>
                </div>
            </div>

        </ng-container>

        <ng-container *ngIf="selectedTab === 2">
            <div class="row align-items-center mb-3">

                <!-- IZQUIERDA -->
                <div class="col-12 col-md-6">
                    <h1 class="mb-1 page-title">Indicadores Operacionales</h1>
                    <p class="subtitle">*En millones de Pesos</p>
                </div>

                <!-- DERECHA -->
                <div class="col-12 col-md-6 d-flex justify-content-md-end gap-3 mt-3 mt-md-0">

                    <!-- Select -->
                    <select class="form-select" style="max-width: 180px;" formControlName="periodoFiltro">
                        <option value="">Seleccione Área</option>
                        <option value="mensual">Mensual</option>
                        <option value="trimestral">Trimestral</option>
                    </select>

                    <!-- Input Fecha -->
                    <input type="date" class="form-control" style="max-width: 180px;" formControlName="fechaFiltro" />



                </div>

            </div>

            <div class="row mt-4">

                <!-- COLUMNA IZQUIERDA (3 cards verticales) -->
                <div class="col-12 col-md-3 d-flex flex-column gap-3">

                    <div class="card-resumen">
                        <h4>Ingresos</h4>
                        <p class="monto">$200.000.000</p>
                        <p class="info">LLevamos 30% del ingreso proyectado</p>
                    </div>

                    <div class="card-resumen">
                        <h4>Gastos</h4>
                        <p class="monto">$200.000.000</p>
                        <p class="info">LLevamos 30% del ingreso proyectado</p>
                    </div>

                    <div class="card-resumen">
                        <h4>Desviación</h4>
                        <p class="monto">$200.000.000</p>
                        <p class="info">LLevamos 30% del ingreso proyectado</p>
                    </div>

                </div>

                <!-- COLUMNA DERECHA (card de 9 columnas) -->
                <div class="col-12 col-md-9">
                    <div class="card-resumen card-grande">
                        <h3>Card Derecha Grande</h3>
                        <p>Contenido adicional...</p>
                    </div>
                </div>

            </div>


            <!-- NUEVA FILA -->
            <div class="row mt-4">

                <!-- CARD IZQUIERDA (COL 2) -->
                <div class="col-12 col-md-2">
                    <div class="card-resumen">
                        <h4>Resumen pequeño</h4>
                        <p>Contenido...</p>
                    </div>
                </div>

                <!-- CARD DERECHA (COL 10) -->
                <div class="col-12 col-md-10">
                    <div class="card-resumen card-grande">
                        <h3>Card Grande 10</h3>
                        <p>Contenido...</p>
                    </div>
                </div>

            </div>


        </ng-container>

        <ng-container *ngIf="selectedTab === 3">
            <div class="row align-items-center mb-3">

                <!-- IZQUIERDA -->
                <div class="col-12 col-md-6">
                    <h1 class="mb-1 page-title">Indicadores Dotación</h1>
                    <p class="subtitle">*En millones de Pesos</p>
                </div>

                <!-- DERECHA -->
                <div class="col-12 col-md-6 d-flex justify-content-md-end gap-3 mt-3 mt-md-0">

                    <!-- Select -->
                    <select class="form-select" style="max-width: 180px;" formControlName="periodoFiltro">
                        <option value="">Seleccione Área</option>
                        <option value="mensual">Mensual</option>
                        <option value="trimestral">Trimestral</option>
                    </select>

                    <!-- Input Fecha -->
                    <input type="date" class="form-control" style="max-width: 180px;" formControlName="fechaFiltro" />



                </div>

            </div>

            <div class="row mt-4 cards-resumen">

                <div class="col-12 col-md-4">
                    <div class="card-resumen">
                        <h4>Ingresos</h4>
                        <p class="monto">$200.000.000</p>
                        <p class="info">LLevamos 30% del ingreso proyectado</p>
                    </div>
                </div>

                <div class="col-12 col-md-4">
                    <div class="card-resumen">
                        <h4>Gastos</h4>
                        <p class="monto">$200.000.000</p>
                        <p class="info">LLevamos 30% del ingreso proyectado</p>
                    </div>
                </div>
            </div>

            <div class="row mt-4 cards-resumen">

                <div class="col-12 col-md-6">
                    <div class="card-resumen">
                        <h4>Ingresos</h4>
                        <p class="monto">$200.000.000</p>
                        <p class="info">LLevamos 30% del ingreso proyectado</p>
                    </div>
                </div>

                <div class="col-12 col-md-6">
                    <div class="card-resumen">
                        <h4>Gastos</h4>
                        <p class="monto">$200.000.000</p>
                        <p class="info">LLevamos 30% del ingreso proyectado</p>
                    </div>
                </div>
            </div>

            <div class="row mt-4 cards-resumen">

                <div class="col-12 col-md-12">
                    <div class="card-resumen">
                        <h4>Ingresos</h4>
                        <p class="monto">$200.000.000</p>
                        <p class="info">LLevamos 30% del ingreso proyectado</p>
                    </div>
                </div>
            </div>

            <div class="row mt-4 cards-resumen">

                <div class="col-12 col-md-12">
                    <div class="card-resumen">
                        <h4>Ingresos</h4>
                        <p class="monto">$200.000.000</p>
                        <p class="info">LLevamos 30% del ingreso proyectado</p>
                    </div>
                </div>
            </div>


        </ng-container>

    </div>

</div>
